
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const MobileAppsHeader = () => {
  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="container">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          <div className="lg:w-1/2">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              <span className="text-blue-700">Mobile Apps</span> für iOS & Android
            </h1>
            <p className="text-xl mb-6 text-gray-700">
              Von der Idee bis zum App Store – wir entwickeln Apps, die Ihre Kunden begeistern und Ihre Geschäftsprozesse mobil machen.
            </p>
            <p className="text-gray-600 mb-8">
              Mit modernen Technologien und einem Fokus auf Benutzerfreundlichkeit erschaffen wir mobile Anwendungen, die Ihre Marke stärken und echten Mehrwert bieten.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-8">
                <a href="#mobile-features">Mehr erfahren</a>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-blue-600 text-blue-600 hover:bg-blue-50">
                <a href="#contact" className="flex items-center">
                  Beratungsgespräch vereinbaren <ArrowRight size={16} className="ml-2" />
                </a>
              </Button>
            </div>
          </div>
          <div className="lg:w-1/2">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img 
                src="https://images.unsplash.com/photo-1605810230434-7631ac76ec81?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80" 
                alt="Mobile App Development" 
                className="w-full h-auto object-cover"
                onError={(e) => {
                  e.currentTarget.src = "https://res.cloudinary.com/dpblhjrjq/image/upload/v1713031332/mobile-app-development_kf9gbz.jpg";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppsHeader;
